module.exports = "/_next/static/images/Connected-e7d84d30d11b8677e4184a260241cd45.webp";